import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBadgeCheck,
} from "@fortawesome/pro-duotone-svg-icons";

const CertifiedBadge = ({...props})=>{
    return <FontAwesomeIcon className="certified-badge" icon={faBadgeCheck} style={{"--fa-primary-color": "#ffffff", "--fa-secondary-color": "#0095ff", "--fa-secondary-opacity": "1", fontSize:'1em', ...props?.style}}/>
}

export default CertifiedBadge;